import { gql } from '@apollo/client'
import { mutate } from 'shared/helpers/graphql'

export async function upsertUnits(payload) {
  return mutate(
    {
      units: [payload],
    },
    gql`
      mutation Upsert_units($units: [units_input]) {
        upsert_units(units: $units) {
          id
        }
      }
    `,
  )
}

export async function deleteUnit(unitId) {
  return mutate(
    {
      deleteUnitsId: unitId,
    },
    gql`
      mutation Delete_units($deleteUnitsId: Int!) {
        delete_units(id: $deleteUnitsId) {
          id
        }
      }
    `,
  )
}
